<template>
  <ankh-list :showPager="false" :showBtnGroup="false" :showSearchForm="false">
    <template #tab-row>
      <el-tabs v-model="activeName">
        <template v-for="item in comp">
          <el-tab-pane :key="item.name" :label="`${$t(item.label)}（${item.count}）`" :name="item.name">
          </el-tab-pane>
        </template>
      </el-tabs>
    </template>

    <template #table="{height}">
      <user-recipe-list
          :height="height"
          :current="activeName"
          :tab-current="activeName"
          :status="activeName" />
    </template>
  </ankh-list>
</template>

<script>
import UserRecipeList from "@/components/user/UserRecipeList";
import {request} from "@/config/request";
import AnkhList from "@/components/list/AnkhList.vue";
export default {
  name: "UserRecipe",
  components: {AnkhList, UserRecipeList},
  data() {
    return {
      activeName: "audit",
      comp: [
        {name: "audit", label: "审核中", count: 0},
        {name: "up", label: "上架中", count: 0},
        {name: "draft", label: "仓库中", count: 0},
      ]
    }
  },
  created() {
    this.loadRecipeCount();
  },
  methods: {
    // 加载食谱统计数量
    async loadRecipeCount() {
      try {
        const params = {
          userNum: this.$route.query.num,
        }
        let res = await request(this.$api.cookbook.listMy, params);
        const countMap = res.countMap;
        this.comp.forEach(item => {
          item.count = countMap[item.name + "Count"] || 0;
        })
      } catch (e) {
        console.error("食谱统计数量", e);
      }
    }
  }
}
</script>

<style scoped>

</style>
